import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { errorActions } from "../store/errorSlice";
import { loaderActions } from "../store/loaderSlice";

export default function Loader(props) {
  const dispatch = useDispatch();
  const isShow = useSelector((state) => state.loader.isShow);
  const [show, setShow] = useState(false);

  const checkIsError = () => {
    if (isShow) {
      setShow(false);
      dispatch(errorActions.setError(true));
    }
  };

  useEffect(() => {
    dispatch(loaderActions.setIsShowUpdated(false));

    return () => {
      dispatch(loaderActions.setIsShowUpdated(true));
    };
  }, []);

  useEffect(() => {
    setShow(isShow);

    const loaderTimeout = setTimeout(() => {
      if (isShow) {
        checkIsError();
      }
    }, 28000);

    return () => {
      clearTimeout(loaderTimeout);
    };
  }, [isShow]);

  return (
    <div>
      {show && (
        <div
          className="fixed inset-0 z-[1500] flex items-center justify-center bg-black/35"
          data-testid="global-loader-backdrop"
          role="status"
          aria-live="polite"
          aria-label="loading"
        >
          <div
            className="h-10 w-10 animate-spin rounded-full"
            style={{
              borderWidth: "4px",
              borderStyle: "solid",
              borderColor: "#ffffff",
              borderTopColor: "transparent",
            }}
          />
        </div>
      )}
      {props.children}
    </div>
  );
}
